import { Component, Input } from '@angular/core';
import { SidStatus } from '../../audit/sid.model';

@Component({
  selector: 'iaud-sid-stepper',
  templateUrl: './sid-stepper.component.html',
  styleUrls: ['./sid-stepper.component.scss']
})
export class SidStepperComponent {

  @Input()
  public set status(v: SidStatus) {
    switch (v) {
      case SidStatus.DRAFT:
      case SidStatus.READY_TO_SUBMIT:
        this.step = 2;
        break;
      case SidStatus.WAIT_FOR_1ST_APPROVAL:
        this.step = 3;
        break;
      case SidStatus.WAIT_FOR_2ND_APPROVAL:
        this.step = 4;
        break;
      case SidStatus.EVIDENCE_SUBMISSION:
        this.step = 5;
        break;
      case SidStatus.EVIDENCE_APPROVAL:
        this.step = 6;
        break;
      case SidStatus.COMPLETED:
        this.step = 7;
        break;
      default:
        this.step = 1;
    }
  }
  @Input()
  step: number;
}
